<template>
  <transition name="slide-fade">
    <div
      v-if="!isFilterOptionsOpened"
      class="search-sort-block m-auto d-flex flex-wrap"
    >
      <div class="search-block">
        <search-input
          :search-block-style="'search-gallery-block-styles'"
          :input-classes="'search-gallery-input'"
          :button-style="'p-0 search-icon-button'"
          :iconsize="'15'"
          :isInspiration="true"
          :iconcolor="'#000'"
          :placeholder-value="'Search Within Inspiration'"
          :on-input="onSearchInput"
          :value="searchTerm"
        />
      </div>
      <div class="sort-block d-flex justify-content-end">
        <div class="select-label">
          <label
            >{{ $resourceString["product.search.display.sort.by"] }}:</label
          >
        </div>
        <div
          class="
            wf-product-display-control
            inspiration-product-display-control-sort-by
          "
        >
          <select
            class="custom-select gallery-select"
            name="inspiration-product-display-control-sort-by"
            @change="setOrdering"
          >
            <option disabled value="">
              {{ $resourceString["product.search.display.sort.by"] }}
            </option>
            <option
              value="DisplayCollectionName asc"
              :selected="
                `${sortOrder} ${isAscendingOrder}` ===
                  'DisplayCollectionName asc'
              "
            >
              {{ $resourceString["product.search.display.sort.by.alphabet"] }}
            </option>
            <option
              value="DisplayCollectionName desc"
              :selected="
                `${sortOrder} ${isAscendingOrder}` ===
                  'DisplayCollectionName desc'
              "
            >
              {{ $resourceString["product.search.display.sort.by.za"] }}
            </option>
            <option value="RoomType" :selected="`${sortOrder}` === 'RoomType'">
              {{ $resourceString["inspiration.display.control.sort.by.room"] }}
            </option>
            <option
              value="InspirationType"
              :selected="`${sortOrder}` === 'InspirationType'"
            >
              {{
                $resourceString[
                  "inspiration.display.control.sort.by.inspiration"
                ]
              }}
            </option>
            <option
              value="ProjectType"
              :selected="`${sortOrder}` === 'ProjectType'"
            >
              {{
                $resourceString["inspiration.display.control.sort.by.projects"]
              }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import SearchInput from "../common/pc-search-input.vue";

export default {
  components: {
    SearchInput
  },
  computed: {
    ...mapGetters({
      searchTerm: "filters/searchTerm",
      sortOrder: "filters/sortOrder",
      isAscendingOrder: "filters/isAscendingOrder",
      isFilterOptionsOpened: "inspirationPage/isFilterOptionsOpened"
    })
  },
  data() {
    return {
      timeout: null
    };
  },
  methods: {
    ...mapActions({
      setSearchTerm: "filters/setSearchTerm",
      setSortOrder: "filters/setSortOrder"
    }),
    onSearchInput(e) {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.setSearchTerm(e?.trim());
      }, 800);
    },
    setOrdering(e) {
      this.setSortOrder(e.target.value);
    }
  }
};
</script>

<style>
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
  max-height: 330px;
}
.slide-fade-enter,
.slide-fade-leave-to {
  max-height: 0;
  opacity: 0;
}
</style>
